import type { DocumentNode } from 'graphql'
import gql from 'graphql-tag'

const listPlans: DocumentNode = gql`
  query ListPlans($state: String) {
    listPlans(state: $state) {
      data {
        autoRenew
        code
        currentlyOffered
        customFields {
          name
          value
        }
        intervalLength
        planProduct
        planSet
        trialLength
        trialUnit
        trialRequiresBillingInfo
        name
        currencies {
          currency
          unitAmount
          setupFee
        }
      }
    }
  }
`

export default listPlans
